// src/components/Footer.jsx
import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      aria-label="Site footer"
      className="bg-[#e81b2c] bg-gradient-to-r from-[#e81b2c] to-[#8e2790] text-white"
    >
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 py-5 border-t border-white/10">
          <p className="text-sm">
            © {year}{" "}
            <span className="font-semibold">Bimari Distribution Ltd.</span> All
            rights reserved.
          </p>

          {/* Optional quick links */}
          <nav className="text-sm">
            <ul className="flex items-center gap-5">
              <li>
                <Link to="/privacy" className="hover:text-white/80">
                  Privacy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-white/80">
                  Terms
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white/80">
                  Contact
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  );
}
